import { useCameraOSD } from "@/contexts/CameraOSDContext";

const SectionDivider = ({ showOsd = false }: { showOsd?: boolean }) => {
  const { brand } = useCameraOSD();
  const isRed = brand === "RED";
  const labelColor = isRed ? "text-accent" : "text-[hsl(var(--osd-yellow))]";

  return (
    <div className="relative w-full px-6 py-2 flex items-center gap-3 font-mono text-[10px] tracking-widest text-foreground/80 uppercase">
      {/* Left cluster — lens & exposure */}
      {showOsd && (
        <div className="flex items-center gap-3 shrink-0">
          <span><span className={labelColor}>LENS</span> {isRed ? "50mm T1.5" : "35mm T1.4"}</span>
          <span className="hidden md:inline opacity-50">·</span>
          <span className="hidden md:inline">ND {isRed ? "0.9" : "0.6"}</span>
          <span className="hidden md:inline opacity-50">·</span>
          <span className="hidden md:inline"><span className={labelColor}>WB</span> 5600K{isRed ? " +5" : "+2"}</span>
          <span className="hidden md:inline opacity-50">·</span>
          <span className="hidden md:inline">SHUTTER {isRed ? "172.8°" : "180°"}</span>
        </div>
      )}

      {/* Solid red bar */}
      <span className="flex-1 h-[2px] bg-accent" />

      {/* Right cluster — battery & media */}
      {showOsd && (
        <div className="flex items-center gap-3 shrink-0">
          <span className="inline-flex items-center gap-1.5 tabular-nums">
            BATT 87%
            <span className="inline-flex items-center" aria-hidden="true">
              <span className="relative flex items-center w-[22px] h-[10px] border border-foreground/80 rounded-[1px] p-[1px]">
                <span className="block h-full w-[87%] bg-foreground/80" />
              </span>
              <span className="block w-[2px] h-[5px] bg-foreground/80 ml-[1px] rounded-r-[1px]" />
            </span>
          </span>
          <span className="hidden md:inline opacity-50">·</span>
          <span className="hidden md:inline tabular-nums">
            {isRed ? "CFx 512GB" : "CODEX 1TB"}
          </span>
          {isRed && (
            <>
              <span className="hidden md:inline opacity-50">·</span>
              <span className="hidden md:inline tabular-nums">TEMP 38°C</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionDivider;
